var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareLinkedin = function SvgShareLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 58 58"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    className: "share_linkedin_svg__cls-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.74 26.87v-.06zM21.08 42.86h-6.21v-18.7h6.21ZM18 21.61a3.24 3.24 0 1 1 0-6.47 3.24 3.24 0 1 1 0 6.47m25.5 21.25h-6.22v-10c0-2.52-.9-4.24-3.15-4.24a3.43 3.43 0 0 0-3.19 2.28 4.3 4.3 0 0 0-.2 1.52v10.44h-6.22s.08-16.95 0-18.7h6.22v2.65a6.16 6.16 0 0 1 5.6-3.09c4.09 0 7.16 2.67 7.16 8.42Z",
    className: "share_linkedin_svg__cls-2"
  })));
};
export default SvgShareLinkedin;